export default {
    headerText: '28px',
    iconText: '24px',
    bigText: '22px',
    mediumText: '18px',
    smallText: '16px',
    evenSmallText: '14px',
    extraSmallText: '12px',
}
